import React from 'react';
import { Alert, Box, Typography } from '@mui/material';
import {
  ActivityCard,
  BulletList,
  FooterNote,
  PrimaryButton,
  ScreenShell,
  ScreenTitle,
  SecondaryButton,
  tokens,
} from '../parts';
import { GoalFlowScreenProps } from './types';

/** "Your SMART Goal" — every commitment, with edit/remove, and the one place the goal is saved. */
export const ReviewScreen: React.FC<GoalFlowScreenProps> = ({ goalFlow }) => (
  <ScreenShell
    background={tokens.surface}
    footer={
      <>
        <Typography sx={{ fontSize: '14px', lineHeight: 1.6, color: tokens.textPrimary }}>
          Once you confirm, this goal will be set for the next four weeks unless you reach out to your Coach to adjust
          it.
        </Typography>
        {goalFlow.saveError && <Alert severity="error">{goalFlow.saveError}</Alert>}
        <PrimaryButton onClick={goalFlow.confirmAndSave} disabled={goalFlow.saving}>
          {goalFlow.saving ? 'Saving…' : 'Confirm & Save SMART Goal'}
        </PrimaryButton>
        {goalFlow.canAddMore && (
          <SecondaryButton onClick={goalFlow.addAnother} disabled={goalFlow.saving}>
            Add Another Activity
          </SecondaryButton>
        )}
        <FooterNote maxActivities={goalFlow.maxActivities} />
      </>
    }
  >
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, mb: 0.5 }}>
        <ScreenTitle large>Your SMART Goal</ScreenTitle>
        <BulletList>
          <li>
            Are these commitments <strong>ACHIEVABLE</strong>?
          </li>
          <li>
            Are they <strong>RELEVANT</strong> to your daily life and motivation for joining We Hate Exercise?
          </li>
        </BulletList>
      </Box>
      {goalFlow.cards.map((card) => (
        <ActivityCard
          key={card.index}
          card={card}
          label={`Commitment ${card.index + 1}`}
          onEdit={() => goalFlow.edit(card.index)}
          onDelete={() => goalFlow.requestDelete(card.index)}
        >
          <Typography sx={{ fontSize: '15px', fontWeight: 400, color: tokens.textPrimary, lineHeight: 1.6 }}>
            I commit to <strong>{card.name}</strong> {card.frequency}× per week for{' '}
            <strong>{card.duration} minutes</strong>
          </Typography>
        </ActivityCard>
      ))}
    </Box>
  </ScreenShell>
);
